// data-testid values for the Tesori d'Europa landing page
export const LANDING = {
  // Header
  header: "header-root",
  headerLogo: "header-logo",
  navHome: "nav-home",
  navDestinazioni: "nav-destinazioni",
  navEsperienze: "nav-esperienze",
  navTesori: "nav-tesori",
  navBlog: "nav-blog",
  navContatti: "nav-contatti",
  navSearch: "nav-search-btn",
  navCta: "nav-cta-explore",
  mobileMenuToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",

  // Hero
  hero: "hero-section",
  heroHeadline: "hero-headline",
  heroSubheading: "hero-subheading",
  heroCta: "hero-cta-start-journey",

  // Pillars
  pillars: "pillars-section",
  pillarsTitle: "pillars-title",
  pillarCulture: "pillar-card-culture",
  pillarFood: "pillar-card-food",
  pillarHidden: "pillar-card-hidden",

  // Storytelling
  storytelling: "storytelling-section",
  storytellingHeadline: "storytelling-headline",
  storytellingCta: "storytelling-cta-philosophy",

  // Blog
  blog: "blog-section",
  blogTitle: "blog-title",
  blogList: "blog-list",
  blogCard: (id) => `blog-card-${id}`,

  // Newsletter
  newsletter: "newsletter-section",
  newsletterHeadline: "newsletter-headline",
  newsletterEmailInput: "newsletter-email-input",
  newsletterSubmit: "newsletter-submit-btn",
  newsletterMessage: "newsletter-feedback",

  // Footer
  footer: "footer-root",
  footerSocialInstagram: "footer-social-instagram",
  footerSocialFacebook: "footer-social-facebook",
  footerSocialPinterest: "footer-social-pinterest",
  footerEmail: "footer-email",
};
